import { render } from "./Abfrage.vue?vue&type=template&id=e104511c&scoped=true"
import script from "./Abfrage.vue?vue&type=script&lang=js"
export * from "./Abfrage.vue?vue&type=script&lang=js"

import "./Abfrage.vue?vue&type=style&index=0&id=e104511c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e104511c"]])

export default __exports__